/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Feat_Fee_35_DescInputs */

const en_upgrade_feat_fee_35_desc = /** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The most competitive rates for high-volume trade.`)
};

const es_upgrade_feat_fee_35_desc = /** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las tarifas más competitivas para comercio de alto volumen.`)
};

const fr_upgrade_feat_fee_35_desc = /** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les tarifs les plus compétitifs pour le commerce à fort volume.`)
};

const de_upgrade_feat_fee_35_desc = /** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die wettbewerbsfähigsten Raten für den High-Volume-Handel.`)
};

const id_upgrade_feat_fee_35_desc = /** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif paling kompetitif untuk perdagangan volume tinggi.`)
};

/** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */
const ja_upgrade_feat_fee_35_desc = en_upgrade_feat_fee_35_desc;

/** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */
const zh_upgrade_feat_fee_35_desc = en_upgrade_feat_fee_35_desc;

/** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */
const ar_upgrade_feat_fee_35_desc = en_upgrade_feat_fee_35_desc;

/** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */
const it_upgrade_feat_fee_35_desc = en_upgrade_feat_fee_35_desc;

/** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */
const ru_upgrade_feat_fee_35_desc = en_upgrade_feat_fee_35_desc;

/** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */
const pt_upgrade_feat_fee_35_desc = en_upgrade_feat_fee_35_desc;

/** @type {(inputs: Upgrade_Feat_Fee_35_DescInputs) => LocalizedString} */
const ko_upgrade_feat_fee_35_desc = en_upgrade_feat_fee_35_desc;

/**
* | output |
* | --- |
* | "The most competitive rates for high-volume trade." |
*
* @param {Upgrade_Feat_Fee_35_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_feat_fee_35_desc = /** @type {((inputs?: Upgrade_Feat_Fee_35_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Feat_Fee_35_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_feat_fee_35_desc(inputs)
	if (locale === "es") return es_upgrade_feat_fee_35_desc(inputs)
	if (locale === "fr") return fr_upgrade_feat_fee_35_desc(inputs)
	if (locale === "de") return de_upgrade_feat_fee_35_desc(inputs)
	if (locale === "ja") return ja_upgrade_feat_fee_35_desc(inputs)
	if (locale === "zh") return zh_upgrade_feat_fee_35_desc(inputs)
	if (locale === "ar") return ar_upgrade_feat_fee_35_desc(inputs)
	if (locale === "id") return id_upgrade_feat_fee_35_desc(inputs)
	if (locale === "it") return it_upgrade_feat_fee_35_desc(inputs)
	if (locale === "ru") return ru_upgrade_feat_fee_35_desc(inputs)
	if (locale === "pt") return pt_upgrade_feat_fee_35_desc(inputs)
	return ko_upgrade_feat_fee_35_desc(inputs)
});